import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location){
  return originalPush.call(this, location).catch(err=>err)
}
import user_routes from './routes.js'

import yet_router from '../../../yet2-vue/src/yet/r'
let yet_route = yet_router(user_routes);
const routes = user_routes.routes.concat(yet_route.routes);
const router = new VueRouter({
  routes
})
router.beforeEach(yet_route.beforeEach);
export default router;